import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

class EvidenceOfInsuranceDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      effective_date:
        props.editDate !== null ? moment(props.editDate * 1000) : moment(),
      expiration_date:
        props.entity.expiration_date !== null
          ? moment(props.entity.expiration_date * 1000)
          : moment().add(1, 'year'),
      set_effective_date: props.entity.set_effective_date,
      focused: false,
      focusedExpired: false,
      error: false
    };
  }

  submitHandler = e => {
    e.preventDefault();

    this.props.loader(true);

    this.props.saveEntity(
      {
        set_effective_date: this.state.set_effective_date,
        effective_date:
          this.state.date === null ? null : this.state.effective_date.unix(),
        expiration_date:
          this.state.date === null ? null : this.state.expiration_date.unix()
      },
      () => {
        this.props.loader(false);
        this.props.toggle();
      }
    );

    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.header}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.entity.evidence_of_insurance_form !== null &&
                this.props.entity.evidence_of_insurance_form
                  .effective_date_requested.length > 0 && (
                  <Row className={'pb-3'}>
                    <Col xs={12}>
                      <div className={'font-weight-bold color-blue'}>
                        User specific Effective Date requested
                      </div>
                      <div>
                        {moment(this.props.entity.effective_date * 1000).format(
                          'MM/DD/YYYY'
                        )}
                      </div>
                    </Col>
                  </Row>
                )}
              <Row>
                <Col>
                  {this.props.entity.evidence_of_insurance_form !== null &&
                    this.props.entity.evidence_of_insurance_form && (
                      <FormGroup check className={'pb-2'}>
                        <Label check>
                          <Input
                            type="radio"
                            checked={this.state.set_effective_date === 1}
                            onClick={e =>
                              this.setState({
                                set_effective_date: 1
                              })
                            }
                          />{' '}
                          Use specific Effective Date requested
                          <br />
                          {moment(
                            this.props.entity.effective_date * 1000
                          ).format('MM/DD/YYYY')}{' '}
                          -{' '}
                          {moment(this.props.entity.effective_date * 1000)
                            .add(1, 'year')
                            .format('MM/DD/YYYY')}
                        </Label>
                      </FormGroup>
                    )}
                  <FormGroup check className={'pb-2'}>
                    <Label check>
                      <Input
                        type="radio"
                        checked={this.state.set_effective_date === 2}
                        onChange={e =>
                          this.setState({
                            set_effective_date: 2
                          })
                        }
                      />{' '}
                      Use Association's master policy dates
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-1'}>
                    <Label check>
                      <Input
                        type="radio"
                        checked={this.state.set_effective_date === 3}
                        onChange={e =>
                          this.setState({
                            set_effective_date: 3
                          })
                        }
                      />{' '}
                      Set other custom dates
                    </Label>
                  </FormGroup>
                  <Row className={'pb-2'}>
                    <Col>
                      <SingleDatePicker
                        date={this.state.effective_date} // momentPropTypes.momentObj or null
                        onDateChange={effective_date =>
                          this.setState({
                            effective_date: effective_date,
                            expiration_date: effective_date
                              .clone()
                              .add(1, 'year')
                          })
                        } // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        block={true}
                        isOutsideRange={() => false}
                        disabled={this.state.set_effective_date !== 3}
                        onFocusChange={({ focused }) =>
                          this.setState({ focused })
                        } // PropTypes.func.isRequired
                        id="edit-eoi-date" // PropTypes.string.isRequired,
                      />
                    </Col>
                    <Col>
                      <SingleDatePicker
                        date={this.state.expiration_date} // momentPropTypes.momentObj or null
                        onDateChange={expiration_date =>
                          this.setState({ expiration_date })
                        } // PropTypes.func.isRequired
                        focused={this.state.focusedExpired} // PropTypes.bool
                        block={true}
                        isOutsideRange={() => false}
                        disabled={this.state.set_effective_date !== 3}
                        onFocusChange={({ focused }) =>
                          this.setState({ focusedExpired: focused })
                        } // PropTypes.func.isRequired
                        id="edit-eoi-date" // PropTypes.string.isRequired,
                      />
                    </Col>
                  </Row>

                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        checked={this.state.set_effective_date === 0}
                        onChange={e =>
                          this.setState({
                            set_effective_date: 0
                          })
                        }
                      />{' '}
                      No Effective / Expiration Dates Display
                      <br />
                      "See Below" on EOI Document
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                {this.props.edit !== undefined ? 'Save' : 'Create'}
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default EvidenceOfInsuranceDateModal;
